module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seller-picker",
    class: {
      'notAllowed': _vm.isDisabled
    }
  }, [_c('multiselect', {
    class: [_vm.size, {
      'pointer': !_vm.isDisabled
    }],
    attrs: {
      "options": _vm.getFinalSellers,
      "allowEmpty": _vm.allowEmpty,
      "multiple": false,
      "group-values": _vm.getGroupValues,
      "showLabels": false,
      "group-label": _vm.getGroupLabel,
      "placeholder": _vm.placeholder,
      "track-by": "id",
      "disabled": _vm.isDisabled,
      "label": _vm.getLabel,
      "openDirection": _vm.openDirection
    },
    on: {
      "input": _vm.update,
      "remove": _vm.remove
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc d-flex flex-row align-items-center"
        }, [_c('span', {
          staticClass: "flexGrow1"
        }, [_vm._v(_vm._s(props.option.label || props.option.brandName || props.option.name))])])]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc d-flex flex-row align-items-center"
        }, [_c('span', {
          staticClass: "flexGrow1"
        }, [_vm._v(_vm._s(props.option.label ? props.option.label : props.option.brandName ? props.option.brandName : props.option.$groupLabel))])])]
      }
    }]),
    model: {
      value: (_vm.selectedSeller),
      callback: function($$v) {
        _vm.selectedSeller = $$v
      },
      expression: "selectedSeller"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No results.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65d6ea14"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/SellerPicker.vue
// module id = 1598
// module chunks = 0